import * as stylex from '@stylexjs/stylex';
import { styles } from '../styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const categories = ['Amp', 'Delay', 'Reverb', 'Tuner'];
export const ControlsCategorySwitch = _ref => {
  let {
    onChange,
    selectedCategory
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    ...stylex.props(styles.controlsCategorySwitch),
    children: categories.map(category => /*#__PURE__*/_jsx("span", {
      ...stylex.props(styles.controlsCategory, selectedCategory === category && styles.controlsCategoryActive),
      onClick: () => onChange(category),
      children: category
    }, category))
  });
};